import React, { Component } from 'react';
import axios from 'axios';
class About extends Component {

  constructor(props)
	  {
		  super(props);

      this.state = {
        AboutUs: []
		  }
    }

    componentDidMount() {

      const $ = window.$;
  
       $( '.footer-area.style-two' ).removeClass( 'mg-top-100' );
  
       axios.get('https://ncr.rachshop.com/api/AboutUs?code=jMG8Gd80MY6ra47faRbKB06jjm5APEc44hUpqepno6_1AzFucmA36g==')
       .then(response => {
          if (response.data) {
             this.setState({      
               AboutUs: response.data
              });
          }
        })
        .catch((error) => {
          console.log(error);
        })
      }

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="about-area bg-gray pd-top-120 pd-bottom-120">
              <div className="container">
                <div className="single-about-inner about-line-right bg-white">
                  <div className="row no-gutter">
                    <div className="col-lg-4 order-lg-12">
                      <div className="thumb" style={{background: 'url('+publicUrl+'assets/img/other/2.png)'}} />
                    </div>
                    <div className="col-lg-8 order-lg-1">
                      <div className="details">
                        <div className="section-title mb-4">
                          <h6> {this.state.AboutUs?.[0]?.title1}</h6>
                          <h2> {this.state.AboutUs?.[0]?.title2}</h2>
                          <p> {this.state.AboutUs?.[0]?.description}</p>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <ul className="single-list-inner">
                              <li>{this.state.AboutUs?.[0]?.list1}</li>
                              <li>{this.state.AboutUs?.[0]?.list2}</li>
                              <li> {this.state.AboutUs?.[0]?.list3}</li>
                              <li>{this.state.AboutUs?.[0]?.list4}</li>
                            </ul>
                          </div>
                          <div className="col-md-6">
                            <ul className="single-list-inner">
                              <li> {this.state.AboutUs?.[0]?.list5}</li>
                              <li>{this.state.AboutUs?.[0]?.list56}</li>
                              { <li>{this.state.AboutUs?.[0]?.list7}</li> }
                            </ul>
                          </div>
                        </div>  
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

        }
}

export default About;
